import { render, staticRenderFns } from "./TotalBet.vue?vue&type=template&id=ea7b8db6&"
import script from "./TotalBet.vue?vue&type=script&lang=js&"
export * from "./TotalBet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports